import Vue from "vue";
import VueRouter from "vue-router";
import Dashboard from "../dashboard/Dashboard";
import Login from "../components/login/Login";
import App from "../App.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: App,
    meta: { requiresAuth: true },
    children: [
      {
        path: "/",
        name: "Dashboard",
        component: Dashboard,
      },
      {
        path: "/books",
        name: "Book",
        component: () => import("../components/books/Books.vue"),
      },
      {
        path: "/books/:id",
        name: "BookDetail",
        component: () => import("../components/books/BookDetail.vue"),
      },
      {
        path: "/authors",
        name: "Author",
        component: () => import("../components/authors/Authors.vue"),
      },
      {
        path: "/authors/:id",
        name: "AuthorDetail",
        component: () => import("../components/authors/AuthorDetail.vue"),
      },
      {
        path: "/activities",
        name: "Activities",
        component: () => import("../components/activities/Activities.vue"),
      },
      {
        path: "/activites/:id",
        name: "ActivityDetail",
        component: () => import("../components/activities/ActivityDetail.vue"),
      },
      {
        path: "/users",
        name: "Users",
        component: () => import("../components/users/Users.vue"),
      },
      {
        path: "/users/:id",
        name: "UserDetail",
        component: () => import("../components/users/UserDetail.vue"),
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  console.log("Nemanja");
  console.log(localStorage.getItem("user"));
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (localStorage.getItem("user")) {
      next();
    } else {
      next("/login"); 
    }
  } else {
    next();
  }
});

export default router;
